import { NotificationModuleType } from './notification-module-type';

export class NotificationStatisticsDto {
  total: number;
  totalUnread: number;
  slices: NotificationStatisticsSliceDto[];
}

export class NotificationStatisticsSliceDto {
  total: number;
  totalUnread: number;
  module: NotificationModuleType;

  static create(
    _module: NotificationModuleType
  ): NotificationStatisticsSliceDto {
    const result = new NotificationStatisticsSliceDto();
    result.total = 0;
    result.totalUnread = 0;
    result.module = NotificationModuleType.WorkItem;
    return result;
  }
}
